var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_8d9e7fc319bd5a3db75f6ce396e151b1/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-092b45cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_8d9e7fc319bd5a3db75f6ce396e151b1/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 